<template>
  <div>
    <h3>Welcome!</h3>
    <h4>Your SV ID is: {{ profile.svid }}</h4> 
    <div v-if="isConfirmedSv" class="row">
      <div class="col col-md-8">
        <Schedule></Schedule>
      </div>
    </div>
    <div v-if="isTeamLeader" class="row">
      <div class="col col-md-8">
        <AppStatus/>
        <Jury v-if="isAfterDeadline && isBeforeJuryDeadline && isAfterJuryReleased"/>
        <Schedule v-if="isAfterSchedulesOut"></Schedule>
      </div>
    </div>
    <div v-else class="row">
      <div v-if="isAfterDeadline" class="col col-md-8">
        <!-- <Schedule></Schedule>-->
        <AppStatus/>
        <Schedule v-if="isAfterSchedulesOut"></Schedule>
      </div>
      <div v-else class="col col-md-8">
        <LiveAppStatus/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import LiveAppStatus from './LiveAppStatus'
  import AppStatus from './AppStatus'
  import Jury from './Jury'
  import Schedule from './Schedule'
  import moment from 'moment'

  export default {
    name: 'SvDashboard',
    data () {
      return {}
    },
    computed: {
      ...mapGetters('user', ['isConfirmedSv']),
      ...mapGetters(['isAfterDeadline', 'isAfterSchedulesOut', 'isAfterJuryReleased']),
      ...mapState('user', ['isTeamLeader']),
      ...mapState('user', ['profile']),
      isBeforeAcceptances: function () {
        return moment().tz('UTC').isBefore(this.$store.state.acceptanceDate)
      },
      isBeforeJuryDeadline: function () {
        return moment().tz('UTC').isBefore(this.$store.state.juryDeadline)
      }
    },
    components: {
      LiveAppStatus: LiveAppStatus,
      AppStatus: AppStatus,
      Jury: Jury,
      Schedule: Schedule
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SvDashboard.vue